import axios from "axios";
import swal from "sweetalert2";

const bundleGroupStore = {
  state: {
    bundles: [],
    sorted_bundles: [],
    gates: [],
    gated_checked: false,
    gated_checked_val: 0,
    bundle_filters: [],
    loading_submit: false,
    name_exist: false,
    bundle_name: "",
  },
  mutations: {
    SET_BUNDLES(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.bundles = obj;
    },
    SET_GATES(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.gates = obj;
    },
    SWITCH_GATED_VALUE(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.gated_checked_val = val;
    },
    SET_GATED_CHECKED(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.gated_checked = val;
    },
    SET_SORTED_BUNDLES(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.sorted_bundles = data;
    },
    LOADING_SUBMIT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.loading_submit = val;
    },
    SET_NAME_EXIST(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.name_exist = val;
    },
    SET_BUNDLE_NAME(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.bundle_name = val;
    },
  },
  actions: {
    switchGatedValue({ commit }, val) {
      const value = val === 0 ? 1 : 0;
      commit("SWITCH_GATED_VALUE", value);
    },

    setGatedChecked({ commit, state }) {
      const val = !!state.gated_checked_val;
      commit("SET_GATED_CHECKED", val);
    },

    setBundleName({ commit }, name) {
      commit("SET_BUNDLE_NAME", name);
    },

    getBundlesSorted({ commit, state }, data) {
      const sortedBundles = [];
      state.bundles.forEach((item) => {
        if (data.group === item.group && data.sub === item.has_subscription) {
          sortedBundles.push(item);
        }
      });

      commit("SET_SORTED_BUNDLES", sortedBundles);
    },

    getAllBundlesFromState({ commit, state }) {
      commit("SET_SORTED_BUNDLES", state.bundles);
    },

    async submitForm({ commit }, fields) {
      commit("LOADING_SUBMIT", true);
      try {
        const response = await axios({
          url: "/bundles/groups/new",
          method: "post",
          data: { allFields: fields },
          transformRequest(data) {
            const formData = new FormData();
            formData.append("label", data.allFields.label);
            formData.append("name", data.allFields.name);
            formData.append("description", data.allFields.description);
            formData.append("locale_id", data.allFields.locale_id);
            formData.append("sort_order", data.allFields.sort_order);
            formData.append("gated_id", data.allFields.gated_id);
            formData.append("gated_code", data.allFields.gated_code);
            formData.append("gated_msg", data.allFields.gated_msg);
            formData.append("bundles", JSON.stringify(data.allFields.bundles));
            if (data.allFields.is_gated) {
              formData.append("is_gated", data.allFields.is_gated);
            }

            return formData;
          },
        });

        if (response.status === 201) {
          swal.fire({
            type: "success",
            title: "Success",
            html: "<h5>New bundle group was added.</h5><br/>",
            showConfirmButton: false,
          });
          window.location.href = "/bundles/groups";
        }
      } catch (error) {
        if (error.response) {
          swal.fire({
            type: "error",
            title: "Error",
            html: `<h5>${error.response.data.message}</h5><br/>`,
            showConfirmButton: true,
          });
        }
        // eslint-disable-next-line no-console
        console.error(error.response);
      }

      commit("LOADING_SUBMIT", false);
    },

    async getBundles({ commit }) {
      try {
        const response = await axios.get("/get-bundles");
        if (response.data.bundles) {
          commit("SET_BUNDLES", response.data.bundles);
          commit("SET_SORTED_BUNDLES", response.data.bundles);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    async getGates({ commit }) {
      try {
        const response = await axios.get("/get-gates");
        if (response.data.gates) {
          commit("SET_GATES", response.data.gates);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    async checkForBundleName({ commit }, name) {
      try {
        const response = await axios.post("/get-bundle-name", { name });

        if (response.data.name) {
          commit("SET_NAME_EXIST", true);
        } else {
          commit("SET_NAME_EXIST", false);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
  },

  getters: {
    bundle_filters(state) {
      const uniqueGroup = [];
      const groupFilters = {};

      state.bundles.forEach((bundle) => {
        if (!groupFilters[bundle.group]) {
          uniqueGroup.push(bundle.group);
          groupFilters[bundle.group] = true;
        }
      });

      // eslint-disable-next-line no-param-reassign
      state.bundle_filters = uniqueGroup;
      return uniqueGroup;
    },
  },
};

export default bundleGroupStore;
